/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Card_Starter_Max_UsersInputs */



/**
* | output |
* | --- |
* | "Starter supports up to 5 users" |
*
* @param {Plan_Card_Starter_Max_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_card_starter_max_users = /** @type {((inputs?: Plan_Card_Starter_Max_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Starter_Max_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Starter unterstützt bis zu 5 Nutzer")
	return /** @type {LocalizedString} */ ("Starter supports up to 5 users")
});